import React, { useEffect, useMemo } from 'react';
import { useFormsContext } from '@ally/forms';
import { Label } from '@ally/metronome-ui';
import { withProps } from '@ally/validator';
import validator from './validator';
import { useComputedValues } from '../../useComputedValues';
import TransferAccountSelect from '../../components/TransferAccountSelect';
var TO_ACCOUNT = 'toAccount';
var ToAccountInput = function (_a, disableAutofill) {
    var accounts = _a.accounts;
    var _b = useFormsContext(), values = _b.values, setFieldValue = _b.setFieldValue, setFieldTouched = _b.setFieldTouched;
    var validate = useMemo(function () { return withProps(validator, { accounts: accounts, values: values }); }, [
        accounts,
        values,
    ]);
    var isIraPaperForm = useComputedValues().isIraPaperForm;
    useEffect(function () {
        if (isIraPaperForm) {
            setFieldValue(TO_ACCOUNT, '');
            setFieldTouched(TO_ACCOUNT, false);
        }
    }, [isIraPaperForm]);
    return (React.createElement(React.Fragment, null,
        React.createElement(Label, { htmlFor: TO_ACCOUNT }, "To account"),
        React.createElement("div", { "data-testid": "to-account" },
            React.createElement(TransferAccountSelect, { name: TO_ACCOUNT, accounts: accounts, prompt: "Select an Account", validate: validate, disableAutofill: disableAutofill, disabled: isIraPaperForm }))));
};
export default ToAccountInput;
//# sourceMappingURL=Input.js.map